module.exports = __webpack_public_path__ + "img/待开盒封面图.e78232c9.png";